<span mat-dialog-close class="close-button">
  <em class="icon-salir"></em>
</span>
<picture>
  <img [src]="assetsUrl + '/images/cdt/icons/general-error-icon.svg'" alt="" />
</picture>
<h2 mat-dialog-title class="title">
  Tuvimos un inconveniente de validación, prueba lo siguiente:
</h2>
<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <div class="additional-info">
      <ul>
        <li class="first">Borra la caché de tu dispositivo</li>
        <li>Recarga la página</li>
        <li>Cambia de dispositivo</li>
        <li>Cambia de red</li>
      </ul>
    </div>
  </div>

  <div class="opacity-box"></div>
</div>
<div mat-dialog-actions class="mat-dialog-actions">
  <button
    id="assisted-sale-button"
    mat-dialog-close
    class="btn btn-degraded blue"
    type="button"
  >
    Entendido
  </button>
</div>
